export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12059.7c122c7b.jpg";